<template>
  <footer class="footer">
    <div class="top-gradient-bar"></div>
    <div class="footer-top">
      <img :src="barraLogos" alt="OTCA Logo" />
    </div>
  </footer>
</template>

<script>
import script from "./script.js";

export default script;
</script>

<style scoped src="./style.css"></style>